/* eslint-disable import/no-cycle */
import React from 'react'

import PropTypes from 'prop-types'

import Button from 'components/button'

import {
  Container,
  ResponseImage,
  Title,
  Description,
  ButtonContainer,
  ButtonSecondary
} from './styled'

const StatusMessage = ({
  srcImage,
  title,
  description,
  buttonLabel,
  onClickHandler,
  secondaryButtonLabel,
  secondaryOnClickHandler,
  bgColor,
  flexDirectionRow,
  secondaryButtonGray,
  flipImage,
  textGray
}) => (
  <Container color={bgColor}>
    <ResponseImage src={srcImage} flip={flipImage} alt="" />
    <Title>{title}</Title>
    <Description dangerouslySetInnerHTML={{ __html: description }} textGray={textGray} />
    <ButtonContainer flexDirection={flexDirectionRow}>
      {buttonLabel && (
        <Button padding="10px 60px" fontSize="16" onClick={onClickHandler}>
          {buttonLabel}
        </Button>
      )}
      {secondaryButtonLabel && secondaryOnClickHandler && (
        <ButtonSecondary
          white
          padding="10px 60px"
          fontSize="16"
          onClick={secondaryOnClickHandler}
          secondaryButtonGray={secondaryButtonGray}
        >
          {secondaryButtonLabel}
        </ButtonSecondary>
      )}
    </ButtonContainer>
  </Container>
)

StatusMessage.propTypes = {
  srcImage: PropTypes.any,
  title: PropTypes.string,
  description: PropTypes.string,
  buttonLabel: PropTypes.string,
  onClickHandler: PropTypes.func,
  secondaryButtonLabel: PropTypes.string,
  secondaryOnClickHandler: PropTypes.func,
  flexDirectionRow: PropTypes.bool,
  secondaryButtonGray: PropTypes.bool
}

export default StatusMessage
